/* This example requires Tailwind CSS v2.0+ */
import React, { Fragment, useRef, useState } from 'react';
import { Transition } from '@headlessui/react';
import CtaBtn from '../UIElements/CtaBtn';
import { BasicGridWithTwoBubbles } from '../Graphics/Block';

function EmailForm({title, location, introText, noBg, colour}) {

  const intialiseInfo = {
    source: location,
    firstName: '',
    lastName: '',
    company: '',
    email: '',
    message: ''
  }

  const [ complete, setComplete ] = useState(false);
  const [ submitted, setSubmitted ] = useState(false);
  const [ userInfo, setUserInfo ] = useState(intialiseInfo)
  const firstNameRef = useRef(null);

  const handleUpdateUserInfo = (attr, value) => {
    const info = {...userInfo};
    info[attr] = value;
    info.source = location;
    console.log('[EmailForm.js] info', info);
    setUserInfo(info);
    if (info && info.firstName !== '' && info.lastName !== '' && info.company !== '' && info.email !== '' && info.message !== '') {
      setComplete(true);
    } else {
      setComplete(false);
    }
  };

  const handleSubmit = async () => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(userInfo)
    };
    const response = await fetch('https://sj1uapt1x3.execute-api.eu-west-1.amazonaws.com/prod/email', requestOptions);
    const data = await response.json();
    if (data && data.status && data.status === "success") {
      setSubmitted(true);
      setUserInfo(intialiseInfo);
      setComplete(false);
    }
  }

  return (
    <div className={`${noBg? 'bg-white' : 'bg-plum-100'} py-14`}>
            <div className='absolute -mt-28 ml-12'>
                <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
                    <circle cx="60" cy="60" r="60" fill="#F4F6F7"/>
                </svg>
            </div>
            <div className='absolute float-right right-0 -mt-56 z-0'>
                <svg width="162" height="320" viewBox="0 0 162 320" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="160" cy="160" r="159.25" stroke="#AEBCE2" strokeWidth="1.5"/>
                </svg>
            </div>
            <div className='hidden md:block absolute float-right right-12 -mt-28 opacity-80'>
                <BasicGridWithTwoBubbles tint={'plum'} />
            </div>
            <div className="max-full xl:mx-auto xl:max-w-7xl mt-6 md:mt-16 min-h-[250px] z-10">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className='mx-10 md:mx-auto lg:ml-5 md:min-w-[450px] xl:min-w-[560px]'>
                        <h2 className={`text-${colour ? colour : 'plum'}-700 font-semibold text-[30px] lg:text-[45px] font-title leading-tight`}>{title || "Get in touch"}</h2>
                        <div className={`max-w-[440px] text-sm text-${colour ? colour : 'plum'}-900 font-light mt-[20px] leading-6 tracking-wide`}>
                            {introText ? introText : `We would love to hear from you, how you are currently making use of data and
                            where you would like to get to.`}
                        </div>
                        <div className='max-w-[440px] text-sm text-global-900 font-light mt-[20px] leading-6 tracking-wide'>
                            Complete our contact form with your name, company email and a brief message and
                            we will get back to you as soon as we can.
                        </div>
                    </div>
                    <Transition
                    as={Fragment}
                    show={submitted}
                    enter="ease-out duration-300 delay-100"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-100"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                    <div className="bg-white rounded-lg shadow-xl inline-block align-bottom  px-4 pt-5 pb-4 text-left overflow-hidden transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6 mx-6 md:mx-0 my-6 md:mt-0">
                        <div>
                        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-ful">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-plum-700">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6.633 10.5c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 012.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 00.322-1.672V3a.75.75 0 01.75-.75A2.25 2.25 0 0116.5 4.5c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 01-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 00-1.423-.23H5.904M14.25 9h2.25M5.904 18.75c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 01-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 10.203 4.167 9.75 5 9.75h1.053c.472 0 .745.556.5.96a8.958 8.958 0 00-1.302 4.665c0 1.194.232 2.333.654 3.375z" />
                            </svg>
                        </div>
                        <div className="mt-3 sm:mt-5">
                            <p className="text-sm text-center text-plum-900">We'll try to get back to you as soon as possible.</p>
                        </div>
                        </div>
                    </div>
                    </Transition>
                    <Transition
                    as={Fragment}
                    show={!submitted}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-100"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                    <div className="inline-block align-bottom px-4 pt-2 pb-4 text-left overflow-hidden transform transition-all sm:my-8 sm:align-middle max-w-full w-full md:max-w-lg sm:p-6 mt-4 md:mt-0">
                        <div className="mt-3 sm:mt-5">
                            <div className="pt-1">
                            <form className="space-y-8">
                                <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                <div className="sm:col-span-3">
                                    <label htmlFor="firstName" className="block text-sm font-light text-plum-900">
                                    First name
                                    </label>
                                    <div className="mt-1">
                                    <input
                                        type="text"
                                        name="firstName"
                                        id="firstName"
                                        autoComplete="given-name"
                                        className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 border h-[50px] py-[15px] px-[20px]"
                                        value={userInfo.firstName || ''}
                                        onChange={(e) => {
                                        handleUpdateUserInfo('firstName', e.target.value)
                                        }}
                                        ref={firstNameRef}
                                    />
                                    </div>
                                </div>

                                <div className="sm:col-span-3">
                                    <label htmlFor="lastName" className="block text-sm font-light text-plum-900">
                                    Last name
                                    </label>
                                    <div className="mt-1">
                                    <input
                                        type="text"
                                        name="lastName"
                                        id="lastName"
                                        autoComplete="family-name"
                                        className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 border h-[50px] py-[15px] px-[20px]"
                                        value={userInfo.lastName || ''}
                                        onChange={(e) => {
                                        handleUpdateUserInfo('lastName', e.target.value)
                                        }}
                                    />
                                    </div>
                                </div>

                                <div className="sm:col-span-6">
                                    <label htmlFor="company" className="block text-sm font-light text-plum-900">
                                    Company
                                    </label>
                                    <div className="mt-1">
                                    <input
                                        id="company"
                                        name="company"
                                        type="company"
                                        autoComplete="company"
                                        className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 border  h-[50px] py-[15px] px-[20px]"
                                        value={userInfo.company || ''}
                                        onChange={(e) => {
                                        handleUpdateUserInfo('company', e.target.value)
                                        }}
                                    />
                                    </div>
                                </div>

                                <div className="sm:col-span-6">
                                    <label htmlFor="email" className="block text-sm font-light text-plum-900">
                                    Work email address
                                    </label>
                                    <div className="mt-1">
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        autoComplete="email"
                                        className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 border  h-[50px] py-[15px] px-[20px]"
                                        value={userInfo.email || ''}
                                        onChange={(e) => {
                                        handleUpdateUserInfo('email', e.target.value)
                                        }}
                                    />
                                    </div>
                                </div>

                                <div className="sm:col-span-6">
                                    <label htmlFor="about" className="block text-sm font-light text-plum-900">
                                    Message
                                    </label>
                                    <div className="mt-1">
                                    <textarea
                                        id="message"
                                        name="message"
                                        rows={4}
                                        className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border border-gray-300 h-[150px] py-[15px] px-[20px]"
                                        value={userInfo.message || ''}
                                        onChange={(e) => {
                                        handleUpdateUserInfo('message', e.target.value)
                                        }}
                                    />
                                    </div>
                                    <p className="mt-2 text-sm text-plum-700">What would you like to know about?</p>
                                </div>

                                </div>
                                <div className="mt-5 sm:mt-6 flex">
                                    <div className='flex-grow'></div>
                                {complete ? 
                                <CtaBtn label={'Send message'} colour={colour ? colour : 'plum'} onClick={handleSubmit} className={'right-0'}/> :
                                <CtaBtn label={'Send message'} disabled={true} onClick={() => console.log('Form invalid')} />
                                }
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                </Transition>
            </div>
        </div>
    </div>
  )
}

function SendLink({location, title, link, label, colour}) {

    const intialiseInfo = {
      source: location,
      title,
      email: '',
      link
    }
  
    const [ complete, setComplete ] = useState(false);
    const [ submitted, setSubmitted ] = useState(false);
    const [ userInfo, setUserInfo ] = useState(intialiseInfo)
  
    const handleUpdateUserInfo = (attr, value) => {
      const info = {...userInfo};
      info[attr] = value;
      info.source = location;
      console.log('[EmailForm.js] SendLink info', info);
      setUserInfo(info);
      if (info && info.email !== '') {
        setComplete(true);
      } else {
        setComplete(false);
      }
    };
  
    const handleSubmit = async () => {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userInfo)
      };
      const response = await fetch('https://sj1uapt1x3.execute-api.eu-west-1.amazonaws.com/prod/email', requestOptions);
      const data = await response.json();
      if (data && data.status && data.status === "success") {
        setSubmitted(true);
        setUserInfo(intialiseInfo);
        setComplete(false);
      }
    }
  
    return (
      <div className="">
        <Transition
            as={Fragment}
            show={submitted}
            enter="ease-out duration-300 delay-100"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-100"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
        <div className="bg-white w-full rounded-lg shadow-md inline-block align-bottom  px-4 pb-4 text-left overflow-hidden transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
            <div>
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-ful">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-plum-700">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6.633 10.5c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 012.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 00.322-1.672V3a.75.75 0 01.75-.75A2.25 2.25 0 0116.5 4.5c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 01-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 00-1.423-.23H5.904M14.25 9h2.25M5.904 18.75c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 01-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 10.203 4.167 9.75 5 9.75h1.053c.472 0 .745.556.5.96a8.958 8.958 0 00-1.302 4.665c0 1.194.232 2.333.654 3.375z" />
                </svg>
            </div>
            <div className="mt-3 sm:mt-5">
                <p className="text-sm text-center text-plum-900">Check your email.</p>
            </div>
            </div>
        </div>
        </Transition>
        <Transition
        as={Fragment}
        show={!submitted}
        enter="ease-out duration-300"
        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enterTo="opacity-100 translate-y-0 sm:scale-100"
        leave="ease-in duration-100"
        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
        <div className="inline-block align-bottom pb-4 text-left overflow-hidden transform transition-all sm:align-middle max-w-full w-full md:max-w-lg sm:p-6">
            <div className="mt-3 sm:mt-5">
                <div className="pt-1">
                <form className="">
                    <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                        <div className="sm:col-span-6">
                        <label htmlFor="email" className="block text-sm font-light text-plum-900">
                        Company email address
                        </label>
                        <div className="mt-1">
                        <input
                            id="email"
                            name="email"
                            type="email"
                            autoComplete="email"
                            className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 border  h-[50px] py-[15px] px-[20px]"
                            value={userInfo.email || ''}
                            onChange={(e) => {
                            handleUpdateUserInfo('email', e.target.value)
                            }}
                        />
                        </div>
                    </div>

                    </div>
                    <div className="mt-1">
                    {complete ? 
                    <CtaBtn label={label} colour={colour} onClick={handleSubmit} className={'right-0'}/> :
                    <CtaBtn label={label} disabled={true} onClick={() => console.log('Form invalid')} />
                    }
                    </div>
                </form>
                </div>
            </div>
        </div>
        </Transition>
      </div>
    )
  }


export {
    EmailForm,
    SendLink
}